import React from "react";
import Image from "next/image";
import Link from "next/link";
import {
  PhoneIcon,
  EmailIcon,
  LocationIcon,
} from "@/components/icons/footer-icon";
import {
  IconsContent,
  footerAccountItems,
  footerShopItems,
} from "@/constants/footer";
import { useSelector } from "react-redux";

export default function Footer() {
  const categories = useSelector((state) => state.categories.categories);

  // const dispatch = useDispatch();

  // useEffect(()=>{
  //   dispatch(fetchCategories());

  // }, [dispatch])
  return (
    <footer className="section-py footer-content">
      <div className="container-main px-3 mx-auto">
        <div className="grid align-items-start footer-sub-content">
          <div className="g-col-12 g-col-xl-3">
            <div className="footer-left-content">
              <Image
                src="/assets/images/footer/logo/logo.svg"
                className="position-static"
                height={48}
                width={167}
                alt="Logo Image"
              />
              <p className="text-white mt-4">
                Discover stylish, tech-savvy wearables at Kalindi — where
                innovation meets elegance in every product.
              </p>
              <div className="mt-4 d-flex align-items-center icons-space">
                {IconsContent.map((item, i) => {
                  return (
                    <Link
                      href={item.href}
                      key={i}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex align-items-center justify-content-center rounded-circle"
                      aria-label={`Visit ${item.name}`}
                      aria-hidden="true"
                    >
                      {item.icon}
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="g-col-12 g-col-xl-9">
            <div className="d-flex align-items-start footer-right-content">
              <div className="foot-category">
                <span className="position-relative foot-title d-inline-block">
                  <h3 className="text-white">Account</h3>
                  <div className="position-absolute bottom-0 bg-white animation-line"></div>
                </span>
                <ul className="list-unstyled ms-0 mb-0  mt-3 mt-md-4 pt-1 d-flex flex-column gap-3">
                  {footerAccountItems.map((item, i) => {
                    return (
                      <li className="text-white" key={i}>
                        <Link
                          href={item.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-white fw-normal text-decoration-none"
                          aria-label={`Visit ${item.title}`}
                        >
                          {item.title}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="foot-category">
                <span className="position-relative foot-title d-inline-block">
                  <h3 className="text-white">Shop</h3>
                  <div className="position-absolute bottom-0 bg-white animation-line"></div>
                </span>
                <ul className="list-unstyled ms-0 mb-0 mt-3 mt-md-4 pt-1 d-flex flex-column gap-3">
                  {footerShopItems.map((item, i) => {
                    return (
                      <li className="text-white" key={i}>
                        <Link
                          href={item.href}
                          className="text-white fw-normal text-decoration-none"
                          aria-label={`Visit ${item.title}`}
                        >
                          {item.title}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="foot-category">
                <span className="position-relative foot-title d-inline-block">
                  <h3 className="text-white">Categories</h3>
                  <div className="position-absolute bottom-0 bg-white animation-line"></div>
                </span>
                <ul className="list-unstyled ms-0 mb-0 mt-3 mt-md-4 pt-1 d-flex flex-column gap-3">
                  {categories?.data?.slice(0, 4).map((item, i) => {
                    return (
                      <li className="text-white" key={i}>
                        <Link
                          href={item.slug}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-white fw-normal text-decoration-none"
                          aria-label={`Visit ${item.category_name}`}
                        >
                          {item.category_name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div>
                <span className="position-relative foot-title d-inline-block">
                  <h3 className="text-white">Contact</h3>
                  <div className="position-absolute bottom-0 bg-white animation-line"></div>
                </span>
                <div className="mt-3 mt-md-4 pt-1">
                  <div className="d-flex flex-column contact-list">
                    <div className="d-flex align-items-center contact-gap">
                      <div className="flex-shrink-1">
                        <PhoneIcon />
                      </div>
                      <Link
                        href="tel:+918141261261"
                        className="text-white fw-normal text-decoration-none"
                      >
                        +91 81412 61261
                      </Link>
                    </div>
                    <div className="d-flex align-items-center contact-gap">
                      <div className="flex-shrink-1">
                        <EmailIcon />
                      </div>
                      <Link
                        href="mailto:care@thekalindi.com"
                        className="text-white fw-normal text-decoration-none"
                      >
                        care@thekalindi.com
                      </Link>
                    </div>
                    <div className="d-flex align-items-satrt contact-gap">
                      <div className="flex-shrink-1">
                        <LocationIcon />
                      </div>
                      <address className="text-white fw-normal text-decoration-none mb-0">
                        <Link
                          href="https://www.google.co.in/maps/place/Dhananjay+Creations+Private+Limited/@21.1805655,72.9583379,17z/data=!3m1!4b1!4m6!3m5!1s0x3be04e63a5de0acb:0x16827f7570270b5d!8m2!3d21.1805605!4d72.9609128!16s%2Fg%2F1wg5wgl_?entry=ttu&g_ep=EgoyMDI1MDQwMi4xIKXMDSoASAFQAw%3D%3D"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-white cursor-pointer"
                          style={{ textDecoration: "none" }}
                        >
                          Dhananjay House, Plot No. 85, Chhatrala Ind Park, Near
                          Kadodara Chowkdi, B/h MacDonald, Kadodara, Surat,
                          Gujarat 394325
                        </Link>
                      </address>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="foot-wrapper my-4"></div>
        <div className="d-flex flex-wrap flex-column flex-xl-row align-items-center gap-1 gap-xxl-3 justify-content-between footer-foot">
          <div className="d-flex align-items-center gap-2">
            <p className="text-white">Made with</p>
            <Image
              src="/assets/images/footer/icons/heart.svg"
              height={26}
              width={26}
              alt="Heart Icon Image"
            />
            <p className="text-white">in India</p>
          </div>
          <p className="text-white text-center">
            Copyright © {new Date().getFullYear()}{" "}
            <Link href="/" className="text-decoration-none">
              Kalindi
            </Link>
          </p>

          <div className="d-flex flex-wrap align-items-center gap-2 justify-content-center">
            <Link
              href="/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none"
            >
              Privacy Policy
            </Link>
            <p className="text-white"> | </p>
            <Link
              href="/terms-conditions"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none"
            >
              Terms and Condition
            </Link>
            <p className="text-white"> | </p>
            <Link
              href="/return-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none"
            >
              Return Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
//
